// import React from 'react';
// import '../styles/Pagination.css';

// function Pagination({ currentPage, pageSize, totalUsers, onPageChange }) {
//   const totalPages = Math.ceil(totalUsers / pageSize);
//   // console.log('totalPages ',totalPages)
//   // console.log('totalUsers ',totalUsers)
//   // console.log('pageSize ',pageSize)
//   const pageNumbers = [...Array(totalPages).keys()].map((num) => num + 1);
  
//   const showFirstPage = currentPage > 1;
//   const showPreviousPage = currentPage > 1;
//   const showNextPage = currentPage < totalPages;
//   const showLastPage = currentPage < totalPages;

//   return (
//     <div>
//       <ul className="pagination">
//         {showFirstPage && (
//           <li>
//             <button onClick={() => onPageChange(1)}>&laquo;</button>
//           </li>
//         )}
//         {showPreviousPage && (
//           <li>
//             <button onClick={() => onPageChange(currentPage - 1)}>&lt;</button>
//           </li>
//         )}
//         {pageNumbers.map((page) => (
//           <li key={page} className={page === currentPage ? 'active' : ''}>
//             <button onClick={() => onPageChange(page)}>{page}</button>
//           </li>
//         ))}
//         {showNextPage && (
//           <li>
//             <button onClick={() => onPageChange(currentPage + 1)}>&gt;</button>
//           </li>
//         )}
//         {showLastPage && (
//           <li>
//             <button onClick={() => onPageChange(totalPages)}>&raquo;</button>
//           </li>
//         )}
//       </ul>
//     </div>
//   );
// }

// export default Pagination;


import React from 'react';
import '../styles/Pagination.css';

function Pagination({ currentPage, pageSize, totalUsers, onPageChange }) {
  const totalPages = Math.ceil(totalUsers / pageSize);

  const showFirstPage = currentPage > 1;
  const showPreviousPage = currentPage > 1;
  const showNextPage = currentPage < totalPages;
  const showLastPage = currentPage < totalPages;

  // Calculate which page numbers to display (current, previous, next)
  const pageNumbers = [];
  if (currentPage > 1) pageNumbers.push(currentPage - 1);
  pageNumbers.push(currentPage);
  if (currentPage < totalPages) pageNumbers.push(currentPage + 1);

  return (
    <div>
      <ul className="pagination">
        {showFirstPage && (
          <li>
            <button onClick={() => onPageChange(1)}>&laquo;&laquo;</button>
          </li>
        )}
        {showPreviousPage && (
          <li>
            <button onClick={() => onPageChange(currentPage - 1)}>&laquo;</button>
          </li>
        )}
        {pageNumbers.map((page) => (
          <li key={page} className={page === currentPage ? 'active' : ''}>
            <button onClick={() => onPageChange(page)}>{page}</button>
          </li>
        ))}
        {showNextPage && (
          <li>
            <button onClick={() => onPageChange(currentPage + 1)}>&raquo;</button>
          </li>
        )}
        {showLastPage && (
          <li>
            <button onClick={() => onPageChange(totalPages)}>&raquo;&raquo;</button>
          </li>
        )}
      </ul>
    </div>
  );
}

export default Pagination;
